import { render, staticRenderFns } from "./RevenueLaba.vue?vue&type=template&id=6d6a9aa9"
import script from "./RevenueLaba.vue?vue&type=script&lang=js"
export * from "./RevenueLaba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports